<template>
  <div class="navbar">
    <div class="content-box box">
      <img class="logo" src="../assets/logo.png">
      <router-link v-for="(item) in nav" :key="item.title" :to="item.link">{{ item.title }}
        <div class="line" />
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavBar',
  data() {
    return {
      nav: [
        { title: 'HOME', link: '/' },
        { title: 'RESEARCH', link: '/research' },
        { title: 'PEOPLE', link: '/people' },
        { title: 'PUBLICATIONS', link: '/publications' },
        // { title: 'PROTOCOLS', link: '/protocols' },
        { title: 'ALBUM', link: '/album' },
        { title: 'NEWS', link: '/news' },
        { title: 'JOIN US', link: '/join' }
      ]
    }
  }
}
</script>

<style scoped>
  .navbar {
    width: 100%;
    min-width: 936px;
    height: 110px;
    background: linear-gradient(162deg, rgba(77, 97, 161, 1) 0%, rgba(39, 55, 94, 1) 100%, rgba(48, 64, 91, 1) 100%);
    text-align: center;
  }

  .box {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .logo {
    width: 223px;
    height: 47px;
  }

  a {
    font-size: 12px;
    font-weight: 600;
    color: rgba(208, 229, 255, 1);
    text-decoration: none;
    position: relative;
  }

  a:hover{
    color: white;
  }

  .router-link-exact-active {
    color: white;
  }

  .router-link-exact-active .line {
    width: 100%;
    height: 2px;
    background: white;
    position: absolute;
    bottom: -11px;
  }
</style>
